import type { Plant, Line, Station, Machine } from './types';
import { faker } from '@faker-js/faker/locale/es';

export const PLANT_DEFS: Plant[] = [
  { id: 'MDC-01', name: 'Madrid-Sur',  city: 'Madrid',     country: 'ES', timezone: 'Europe/Madrid' },
  { id: 'VLL-02', name: 'Valladolid',  city: 'Valladolid', country: 'ES', timezone: 'Europe/Madrid' },
  { id: 'ZAR-03', name: 'Zaragoza',    city: 'Zaragoza',   country: 'ES', timezone: 'Europe/Madrid' },
];

export function generatePlants(): Plant[] {
  return PLANT_DEFS;
}

const LINE_FAMILIES: Line['family'][] = ['cabina', 'contrapeso', 'componentes', 'mixta'];

export function generateLines(plants: Plant[], count: number = 8): Line[] {
  const lines: Line[] = [];
  const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
  for (let i = 0; i < count; i++) {
    const plant = plants[i % plants.length];
    const letter = letters[i];
    lines.push({
      id: `L-${plant.id.split('-')[0]}-${letter}`,
      name: `Línea ${letter}`,
      plant: plant.id,
      family: LINE_FAMILIES[i % LINE_FAMILIES.length],
    });
  }
  return lines;
}

const STATION_TYPES: Station['type'][] = ['cnc', 'soldadura', 'pintura', 'ensamblaje', 'inspeccion', 'embalaje'];

export function generateStations(lines: Line[], count: number = 24): Station[] {
  const stations: Station[] = [];
  for (let i = 0; i < count; i++) {
    const line = lines[i % lines.length];
    const idx = Math.floor(i / lines.length) + 1;
    const type = STATION_TYPES[i % STATION_TYPES.length];
    stations.push({
      id: `ST-${line.name.split(' ')[1]}${idx}`,
      name: `Estación ${line.name.split(' ')[1]}${idx} · ${type}`,
      line: line.id,
      plant: line.plant,
      type,
    });
  }
  return stations;
}

const MACHINE_TYPES: Machine['type'][] = ['CNC', 'LASER', 'ROBOT', 'PRESS', 'AGV', 'CAMERA', 'OVEN'];
const MACHINE_NAMES: Record<Machine['type'], string[]> = {
  CNC: ['Fresadora CNC', 'Torno CNC', 'Centro mecanizado'],
  LASER: ['Cortadora láser CO2', 'Marcadora láser fibra'],
  ROBOT: ['Robot soldadura MIG', 'Robot pick&place'],
  PRESS: ['Prensa hidráulica', 'Prensa excéntrica'],
  AGV: ['AGV transporte', 'AGV apilador'],
  CAMERA: ['Cámara inspección 4K', 'Sistema visión 3D'],
  OVEN: ['Horno secado', 'Horno tratamiento térmico'],
};

const MACHINE_STATUS: Array<{ value: Machine['status']; weight: number }> = [
  { value: 'RUNNING', weight: 0.55 },
  { value: 'PAUSED', weight: 0.15 },
  { value: 'IDLE', weight: 0.18 },
  { value: 'ERROR', weight: 0.05 },
  { value: 'MAINTENANCE', weight: 0.07 },
];

export function generateMachines(stations: Station[], count: number = 35): Machine[] {
  const machines: Machine[] = [];
  for (let i = 0; i < count; i++) {
    const station = stations[i % stations.length];
    const type = faker.helpers.arrayElement(MACHINE_TYPES);
    const name = `${faker.helpers.arrayElement(MACHINE_NAMES[type])} #${String(i + 1).padStart(2, '0')}`;
    machines.push({
      id: `M-${String(i + 1).padStart(3, '0')}`,
      name,
      type,
      status: faker.helpers.weightedArrayElement(MACHINE_STATUS),
      station: station.id,
      plant: station.plant,
      line: station.line,
      oee: faker.number.float({ min: 62, max: 96, fractionDigits: 1 }),
      installedAt: faker.date.past({ years: 12 }).toISOString().split('T')[0],
    });
  }
  return machines;
}
